import { Directive, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/** Confirm one input against an other */
/** Also supports confirming against a 3rd input. ex password cant match email or username **/
export function confirmValueValidator(confirmAgainst: AbstractControl, notEquals: boolean, reverse: boolean, alsoReverseConfirm: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        //const forbidden = 
        var keyValue = { 'confirmation': { value: control.value } };
      
        // these will be undefined if empty
        var controlValue; 
        var confirmAgainstValue;
        var alsoReverseConfirmValue;

        if (!control.value)
            controlValue = '';
        else
            controlValue = control.value;

        if (!confirmAgainst.value)
            confirmAgainstValue = '';
        else
            confirmAgainstValue = confirmAgainst.value;

        

        var isValid = (controlValue != confirmAgainstValue) ? false : true;
            //validateDateOfBirth(control.value);
        if (notEquals) {
            isValid = !isValid;
        }
        if (reverse) {

            if (!isValid)
                confirmAgainst.setErrors(keyValue);
            else {
                if (confirmAgainst.errors) {
                    if (confirmAgainst.errors['confirmation'])
                        delete confirmAgainst.errors['confirmation'];
                    if (!Object.keys(confirmAgainst.errors).length) confirmAgainst.setErrors(null);
                }
            }

            return null;
        }

        if (alsoReverseConfirm) {
            if (!alsoReverseConfirm.value)
                alsoReverseConfirmValue = '';
            else
                alsoReverseConfirmValue = alsoReverseConfirm.value;
            var isReverseValid = (controlValue == alsoReverseConfirmValue) ? true : false;

            if (!isReverseValid)
                alsoReverseConfirm.setErrors(keyValue);
            else {
                if (alsoReverseConfirm.errors) {
                    if (alsoReverseConfirm.errors['confirmation'])
                        delete alsoReverseConfirm.errors['confirmation'];
                    if (!Object.keys(alsoReverseConfirm.errors).length) alsoReverseConfirm.setErrors(null);
                }
            }

            //return null;
        }


        return !isValid ? keyValue : null;
    };
}


@Directive({
    selector: '[confirmValue]',
    //providers: [{ provide: NG_VALIDATORS, useExisting: ConfirmValueValidatorDirective, multi: true }]
})
export class ConfirmValueValidatorDirective  {
    @Input() confirmValue: AbstractControl;

    @Input() confirmAgainst: AbstractControl;

    // For resetting validation of target field, because validatio on occurs when "this" changes
    @Input() reverse: boolean;

    // For when you want an input to not match another input
    @Input() notEquals: boolean;


    // For when your input must compare against two different fields, this way can use same directive
    @Input() alsoReverseConfirm: AbstractControl;
    /*
    validate(control: AbstractControl): { [key: string]: any } {
        if (this.confirmValue) {
            if (!this.notEquals) {
                this.notEquals = false;
            }

            if (!this.reverse) {
                this.reverse = false;
            }

            if (!this.alsoReverseConfirm) {
                this.alsoReverseConfirm = null;
            }
            return confirmValueValidator(this.confirmValue, this.notEquals, this.reverse, this.alsoReverseConfirm)(control);
        }
        return null;
            
    }
    */


    @HostListener('focusout', ['$event.target'])
    onFocusout(target) {


        this.validate();
        


    }

    @HostListener('document:triggerValidation', ['$event.target'])
    onsubmit() {
        this.validate();
    }

    validate() {
        if (this.confirmAgainst) {
            if (!this.notEquals) {
                this.notEquals = false;
            }

            if (!this.reverse) {
                this.reverse = false;
            }

            if (!this.alsoReverseConfirm) {
                this.alsoReverseConfirm = null;
            }
            
            if (!this.confirmValue.errors) {

                this.confirmValue.setErrors(confirmValueValidator(this.confirmAgainst, this.notEquals, this.reverse, this.alsoReverseConfirm)(this.confirmValue));

            }
        }

    }




}

